import { computed } from '@vue/composition-api'
import { min } from '@/utils/formatDate'

export default ({
  name: 'MobileOrderCard',
  props: { order: Object },
  setup(props) {
    const orderStartDate = props.order.type === 'Tracker' ? props.order.startTime : props.order.dateStart

    const getStatusColor = () => {
      if (props.order.type === 'Tracker') return 'success'
      return !props.order.canBeBreaked ? 'warning' : 'success'
    }

    const getStatus = () => {
      if (props.order.type === 'Tracker') return props.order.driverTripActive ? 'В работе' : 'Не активен'
      if (props.order.inWork) return 'В работе'
      return !props.order.canBeBreaked ? 'Перерыв' : 'Не активен'
    }

    return {
      date: computed(() => min(new Date(orderStartDate))),
      getStatusColor,
      getStatus,
    }
  },
})
